module.exports = __webpack_public_path__ + "img/3_1.222b0295.png";